module.exports = __webpack_public_path__ + "static/media/split.c71d69ee.svg";